import React, { useEffect, useRef } from "react";
import Footer from "../../components/Footer_/Footer";
import CommonHero from "../../components/CommonHero_/CommonHero";
import DynamicProducts from "../../components/DynamicProducts/DynamicProducts";
import { useParams } from "react-router-dom";
import Reviews from "../../components/Reviews_/Reviews";
import { Helmet } from "react-helmet";
import { getCategoryDetailsByName } from "../../actions/categoryActions";
import { useDispatch, useSelector } from "react-redux";

const ShopScreen = () => {
  const myRef = useRef(null);
  const dispatch = useDispatch();
  const params = useParams();
  const query = params.keyword;
  const selectedCategory = params.category;

  const executeScroll = () => myRef.current.scrollIntoView();

  // Redux state
  const categoryDetailsByName = useSelector(
    (state) => state.categoryDetailsByName
  );
  const { categoryByName } = categoryDetailsByName;

  // Fetch category details if param is present
  useEffect(() => {
    if (selectedCategory) {
      dispatch(
        getCategoryDetailsByName(selectedCategory.replaceAll("-", "%20"))
      );
    }
  }, [selectedCategory, dispatch]);

  useEffect(() => {
    if (query) {
      executeScroll();
    }
  }, [query]);

  const metaTitle = !selectedCategory
    ? "Shop Solar, Batteries & Inverters | EG4, EP Cube, EcoFlow | TRU Off Grid"
    : categoryByName?.metaTitle ||
      `${selectedCategory} at TRU Off Grid | Free Shipping Across Canada`;

  const metaDescription = !selectedCategory
    ? "Shop top-selling EcoFlow Batteries and much more. Enjoy an 11-year warranty, free charger, and free shipping Canada-wide."
    : categoryByName?.metaDescription ||
      `Find the best deals on ${selectedCategory} at TRU Off Grid. Free shipping across Canada.`;

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="keywords" content="Batteries in Ontario" />
        {!selectedCategory ? (
          <link rel="canonical" href="https://www.truoffgrid.com/shop" />
        ) : (
          categoryByName.canonical && (
            <link
              rel="canonical"
              href={categoryByName.canonical}
              key="canonical"
            />
          )
        )}
        <meta name="description" content={metaDescription} />
      </Helmet>
      <CommonHero
        shopHero={true}
        // image="/images/hero-shop.jpg"
        heading="Shop All of our Energy Solutions Below"
      />
      <DynamicProducts Ref={myRef} />
      <Reviews />
      <Footer newsletter={true} />
    </>
  );
};

export default ShopScreen;
